import RenderMarkdown from './RenderMarkdown';

export default RenderMarkdown;
